import React from 'react'
import ImgUtil from '../../../../utils/img.utils'
import formatInlineCode from '../../../../utils/shortTextFormatting'
import Typography from '../../typography'
import VideoPlayer from '../../videoPlayer'
import WrapperImage from '../../wrapperImage'

export const renderAssets = ({
  animationAsset,
  videoId,
  videoUrl,
  videoPosterImg,
  videoType,
  bgVideoAltText,
  start,
  imageOverlay,
}: any) => {
  if (animationAsset) {
    let last = animationAsset.lastIndexOf('.')
    return animationAsset.substring(last).includes('.mp4') ? (
      <video src={animationAsset} playsInline />
    ) : (
      <WrapperImage alt={bgVideoAltText} src={animationAsset} threshold={650} />
    )
  } else if (videoId || videoUrl) {
    return (
      <VideoPlayer
        width={'100%'}
        height="335"
        videoId={videoId}
        videoUrl={videoUrl}
        img={videoPosterImg}
        type={videoType}
        backgroundAltText={bgVideoAltText}
        backgroundImgParams={'width=600, height=335'}
        start={start}
        imageOverlay={imageOverlay}
      />
    )
  }
}

export const TileBox = ({ data, index }: any) => {
  return (
    <div className="tile-box" data-cy={`tile-box` + index}>
      {data?.icon && (
        <div className="icon">
          <WrapperImage
            src={ImgUtil.getResizedImageUrl(data?.icon?.image?.file?.url, `width=96, height=96`)}
            alt={data?.icon?.altText}
            threshold={650}
          />
        </div>
      )}
      <Typography type="leadXS" className="title">
        {formatInlineCode(data?.title)}
      </Typography>
      <Typography type="bodyXS" className="desc font__inter">
        {formatInlineCode(data?.description)}
      </Typography>
    </div>
  )
}
